import React, {ReactNode} from "react";
import {translate} from "@util"; // Adjust import path as needed
import {useSelector} from "react-redux";
import {Typography, TypographyVariant} from "@mui/material";
import {Selectors} from "@core/store/selectors";

interface FormattedMessageProps {
  id: string;
  values?: Record<string, ReactNode | string | number>;
  variant?: TypographyVariant;
}

export const FormattedMessage: React.FC<FormattedMessageProps> = ({
  id,
  values,
  variant,
}) => {
  // Subscribe to language changes so the component re-renders when language changes
  useSelector(Selectors.locale);

  const text = translate(id);

  if (!values) {
    return <>{text}</>;
  }

  // Regex to match %key%
  // Using capture group so split includes the separators
  const parts = text.split(/(%[^%]+%)/g);

  return (
    <Typography variant={variant}>
      {parts.map((part, index) => {
        // checks if the part is a placeholder like %name%
        const match = part.match(/^%([^%]+)%$/);
        if (match) {
          const key = match[1];
          if (key in values) {
            return <React.Fragment key={index}>{values[key]}</React.Fragment>;
          }
        }
        // If not a placeholder or value not found, return the text part
        return <React.Fragment key={index}>{part}</React.Fragment>;
      })}
    </Typography>
  );
};
